// extracted by mini-css-extract-plugin
var _1 = "SubmissionModal_modal__T6tJz";
export { _1 as "modal" }
